/*
 * Estimated delivery date, same rule as Pickentory's /api/customizer/delivery-estimate
 * (the Ordered → Shipped → Delivered timeline on product pages):
 *   order day  = today if before 10 AM Eastern, otherwise tomorrow
 *   ship day   = order day + 7 business days (Mon–Fri)
 *   delivered  = ship day + 2 business days
 * Fills every [data-osdtg-eta] element. Liquid prints a fallback first; this keeps the
 * date right even when Shopify serves a cached page.
 */
(function () {
  var PRODUCTION_DAYS = 7;
  var SHIPPING_DAYS = 2;
  var CUTOFF_HOUR_ET = 10;
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function easternNow() {
    // Wall-clock parts in America/New_York, as a plain local Date (only y/m/d/h are used).
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23',
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = Number(p.value); });
    return { date: new Date(parts.year, parts.month - 1, parts.day), hour: parts.hour };
  }

  function addBusinessDays(d, n) {
    var out = new Date(d.getTime());
    var count = 0;
    while (count < n) {
      out.setDate(out.getDate() + 1);
      var wd = out.getDay();
      if (wd !== 0 && wd !== 6) count++;
    }
    return out;
  }

  function label(d) {
    return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  function render() {
    var now = easternNow();
    var order = new Date(now.date.getTime());
    if (now.hour >= CUTOFF_HOUR_ET) order.setDate(order.getDate() + 1);
    var ship = addBusinessDays(order, PRODUCTION_DAYS);
    var delivered = addBusinessDays(ship, SHIPPING_DAYS);
    var text = { delivery: label(delivered), ship: label(ship) };
    document.querySelectorAll('[data-osdtg-eta]').forEach(function (el) {
      var kind = el.getAttribute('data-osdtg-eta') || 'delivery';
      if (text[kind]) el.textContent = text[kind];
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();
